module.exports = __webpack_public_path__ + "img/winerackdog38.899824dd.jpg";